export default {
    EMPLOYED: 'employed',
    RETIRED: 'retired',
    NOT_EMPLOYED: 'not-employed',
};
